import Cookies from 'js-cookie';
import { FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, FRONT_USER_ROLE_COOKIE_NAME, FRONT_USER_PASSWORD_IN_COOKIE_NAME } from './auth/constants';
import { PUBLIC_URL, SERVER_URL } from './constants';


export function simpleArrStrToStr (arr) {
  return arr.join(" ");
}

export const getString = (value) => {
  if (typeof(value) === 'number') {
    return value.toString();
  }
  return value;
}

export const getFloat = (value) => {
  if (typeof(value) === 'string') {
    return parseFloat(value);
  }
  return value;
}

export const computeLLR = (n12,n1,n2,N,spec ) => {
	// spec indicates whether we are doing specificity computation
	// in this case the value should be corrected : f=n12, t=n1, F=n12+n2, T=N+n1
	if (spec) {
		n2+=n12;
		N+=n1;
	}

	if (n12*n1*n2*N===0) {
		// console.log("Spécificité non définie : n1=n1, n2=n2, n12=n12, N=N");
		return 0;
	}	
	
	const ePP=n1*n2/N;
	const ePA=n1*(N-n2)/N;
	const eAP=(N-n1)*n2/N;
	const eAA=(N-n1)*(N-n2)/N;
	
	if (n12>n2) {
		n12=n2
	}
	if (n12>n1) {
		n12=n1
	}

	if (N-n1-n2+n12<0) {
		console.log("anomalie : N=",N,", n1=",n1,", n2=",n2,", n12=",n12) ;
		return 0;
	}
	const lPP=n12*Math.log(n12/ePP);
	const lPA=(n1-n12>0)?(n1-n12)*Math.log((n1-n12)/ePA):0;
	const lAP=(n2-n12>0)?(n2-n12)*Math.log((n2-n12)/eAP):0;
	const lAA=(N-n1-n2+n12>0)?(N-n1-n2+n12)*Math.log((N-n1-n2+n12)/eAA):0;

	const coeff=(n12>=ePP)? 1:-1;
	
	return coeff*2*(lPP+lPA+lAP+lAA);
}

export const lemmaCat = (q) => {
	if (q) { 
		let s=q.replace(/::.*/,"");
		s=s.replace(/&&/g," ");
		s=s.replace(/<.*?l=([^,]*),c=([^,>]*)[^>]*>/g,"$1_$2");
		s=s.replace(/<.*?l=([^,]*)[^>]*>/g,"$1_.*");
		s=s.replace(/<.*?w=([^,]*)[^>]*>/g,"$1_.*");
		return s;
	}
	return ""
}

// round to 2 digit after point - but problem with float number bug
export const rounded = (value,n) => {
	if (n===null) {
		n=2
	}
	if (value===null) {
		return ""
	}
	const val=parseFloat(value);
    if (val === Math.round(val)) {
      return val
    }
	if ((typeof val)=== "number" ) {
    	return Number(val.toFixed(n));
	} else {
		return val;
	}
};

// in this version, a regex is used to get the rounded number
// the return value is a string
export const format2dec = (value) => {
	if (value) {
		const val=value.toString();
		return val.replace(/([.]\d\d)\d*/,"$1");
	} else {
		return "0"
	}
};

// open a popup that displays conllu trees for a given sentence
export const openConlluPopup = (lang,collection,sentId) => {

    if (sentId) {
      const endpoint = '/conllu.js.ajax.php';
      const data='?lang='+lang+"&sent_id="+sentId+"&collection="+collection;
      const url = process.env.REACT_APP_API_BASE + endpoint + data ;

      const w=800;
      const h=300;
      var top=(window.screen.height-h)/2; 
      var left=(window.screen.width-w)/2;
      window.open(url,"","top="+top.toString()+",left="+left.toString()+",width="+w.toString()+",height="+h.toString()+",menubar=no,scrollbars=yes,statusbar=no,modal=yes,alwaysRaised=yes"); 
    }
};

// open a popup that displays conllu trees for a given sentence
export const openPagePopup = (lang,collection,fileId,sentId,aligned_language) => {
 	const endpoint = '/dashboard';
	let data='?lang='+lang+"&collection="+collection+"&fileId="+fileId+"&sentNum="+sentId+"&query=__read__";
	if (aligned_language) {
		data+="&aligned_language="+aligned_language;
	}
	const url = SERVER_URL+ PUBLIC_URL + endpoint + data ;

	const w=1000;
	const h=1000;
	var top=(window.screen.height-h)/2; 
	var left=(window.screen.width-w)/2;
	window.open(url,"","top="+top.toString()+",left="+left.toString()+",width="+w.toString()+",height="+h.toString()+",menubar=no,scrollbars=yes,statusbar=no,modal=yes,alwaysRaised=yes"); 
};


// renewal of the session by using the saved cookies for credential
export const refreshSignIn = () => {
	if (Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME) &&  Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME)) {
		const login=Cookies.get(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME);
		const password= Cookies.get(FRONT_USER_PASSWORD_IN_COOKIE_NAME); 
	
		const endpoint = '/signIn.ajax.php';
		fetch(
		process.env.REACT_APP_API_BASE + endpoint, {
			credentials: process.env.REACT_APP_CREDENTIALS, 
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ login, password })
		})
		.then((res) => {
			if (res.status !== 200) {
				console.log(`Credential error when renewing signin ${endpoint}`);
			} else {
				res.json().then((data) => {
					// set front-end specific cookie, expire at the end of session (like the backend session cookie)
					// allow to reopen the user session later without login form
					Cookies.set(FRONT_USER_FRONT_LOGGED_IN_COOKIE_NAME, login);
					Cookies.set(FRONT_USER_PASSWORD_IN_COOKIE_NAME, password);
					Cookies.set(FRONT_USER_ROLE_COOKIE_NAME, data['role']);
					
				})
			}
		})
		.catch(() => {
			console.log(`Network error when trying to fetch ${endpoint}`);
		})
	}
};